/** Fisher–Yates shuffle then take up to `count` items (copy; input unchanged). */
export function shuffleAndSlice<T>(items: readonly T[], count: number): T[] {
  const copy = [...items]
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const a = copy[i] as T
    copy[i] = copy[j] as T
    copy[j] = a
  }
  const n = Math.min(count, copy.length)
  return copy.slice(0, n)
}
